import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { cn } from '@/shadcn-ui/utils';

export default function LocationArrow({
  fillPrimary = colors.blue30,
  className,
}: SvgIconCommonProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      className={cn('h-[16px] w-[16px]', className)}
      fill="none"
    >
      <path
        d="M2.13636 8.6062C1.87456 8.6062 1.65556 8.55063 1.47935 8.43949C1.30817 8.3233 1.18231 8.1768 1.10175 7.99998C1.0212 7.82317 0.988473 7.63878 1.00358 7.44681C1.02372 7.24979 1.09168 7.06287 1.20748 6.88606C1.32831 6.70924 1.50452 6.57032 1.73611 6.46928L13.1622 1.18003C13.4743 1.03858 13.7638 0.980482 14.0306 1.00574C14.2975 1.031 14.5165 1.12446 14.6876 1.28612C14.8588 1.44272 14.9595 1.65237 14.9897 1.91507C15.025 2.17271 14.9696 2.46319 14.8236 2.78651L9.575 14.2061C9.4592 14.4537 9.31068 14.6406 9.12944 14.7669C8.95322 14.8982 8.76443 14.974 8.56304 14.9942C8.36669 15.0144 8.1779 14.9816 7.99665 14.8957C7.82044 14.8149 7.67695 14.6861 7.56619 14.5093C7.45543 14.3375 7.40005 14.1253 7.40005 13.8727L7.3925 8.75018C7.3925 8.66935 7.35222 8.62894 7.27167 8.62894L2.13636 8.6062Z"
        fill={fillPrimary}
      />
    </svg>
  );
}
